module.exports = __webpack_public_path__ + "MITSUBISHI-logo.png";